import { createAsyncThunk } from '@reduxjs/toolkit';
import { vendorPackagingService, packagingError } from '@qcdoc/shared/services/repositories/vendorPackagingService.ts';

export interface VendorIdentityScope { userName: string; sessionKey: string }
export const resolveVendorIdentity = createAsyncThunk<string | null, VendorIdentityScope, { rejectValue: string }>('vendorIdentity/resolve', async ({ userName }, { rejectWithValue }) => {
  if (!userName) return null;
  try { return await vendorPackagingService.identity(userName) || null; }
  catch (error) { return rejectWithValue(packagingError(error)); }
});